export default __webpack_public_path__ + "static/media/explore_destination_img5.a9fb85c7.jpg";